import CellLoader from '../Cell/CellLoader';
import MultipleContentCell from './MultipleContentCell';

/**
 *
 */
export default class MultipleContentCellLoader extends CellLoader {
    /**
     * @return {{mixins, name, props}}
     */
    vueComponent() {
        return MultipleContentCell;
    }

    /**
     * @return {{}}
     */
    props() {
        return {
            avatar: this.config.avatar,
            textAvatar: this.config.textAvatar,
            image: this.config.image,
            imageWidth: this.config.imageWidth,
            imageHeight: this.config.imageHeight,
            imageCircle: this.config.imageCircle,
            imageRound: this.config.imageRound,
            icon: this.config.icon,
            avatarAction: this.config.avatarAction,
            primaryContent: this.config.primaryContent,
            primaryContentLink: this.config.primaryContentLink,
            determineSecondaryContent: this.config.determineSecondaryContent,
            determineSecondaryContentCallback: this.config.determineSecondaryContentCallback,
            secondaryContent: this.config.secondaryContent,
            tertiaryContent: this.config.tertiaryContent,
            bottomContentSeparator: this.config.bottomContentSeparator,
            lockedFieldName: this.config.lockedFieldName,
            primaryContentLinkParam: this.config.primaryContentLinkParam,
            badge: this.config.badge,
            primaryContentClasses: this.config.primaryContentClasses,
            isLocked: this.config.isLocked,
            meta: this.config.meta,
            hoverable: this.config.hoverable,
            determinePrimaryContent: this.config.determinePrimaryContent,
            determinePrimaryContentCallback: this.config.determinePrimaryContentCallback,
            secondaryContentClasses: this.config.secondaryContentClasses,
            hasAvatar: this.config.hasAvatar,
            dynamicAvatar: this.config.dynamicAvatar,
            dynamicAvatarCallback: this.config.dynamicAvatarCallback,
            hasMultiSelect: this.config.hasMultiSelect,
            hidePrimaryLinkCallback: this.config.hidePrimaryLinkCallback,
            primaryContentClassesCallback: this.config.primaryContentClassesCallback,
        };
    }
}
